;(function ( $ ) {

    /**
     *  helpTopics
     *  accordion / filter / search
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'helpTopics';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.registerEvents();

            if($(this.element).find('.filter').length){
                this.enableFilter();
            }
            this.filter();
        },
        registerEvents: function() {
            var _this = this;

            $(this.element).find('[data-collapsible="true"]').find('h4').on('click', function(e) {
                e.preventDefault();
                var element = $(this).parent();
                element.toggleClass('is-active');
                //if (element.hasClass('is-active')){
                //    $('body').animate({'scrollTop': element.offset().top - 40 });
                //}
            });

            window.addEventListener("hashchange", (function (e) {
                _this.filter();
            }));

        },

        enableFilter: function() {
            var _this = this,
                $filter = $(this.element).find('.filter').find('.item');

            $filter.each(function(i, el) {
                var element = $(el),
                    hash = element.find('a').attr('href').substr(1);
                if ($('.group[data-filter="' + hash + '"]').length) {
                    element.removeClass('is-disabled');
                }
            });
        },

        filter: function() {
            //filter
            var _this = this,
                hash = window.location.hash.substr(1),
                $groups = $(_this.element).find('.group'),
                $search = $groups.filter('[data-filter="' + hash + '"]').first(),
                $anker = $groups.find('.item').filter('[data-anker="' + hash + '"]').first(),
                $collapsible = false,
                $filter = $(this.element).find('.filter').find('li'),
                $active = $filter.find('a').filter('[href="#' + hash + '"]').parent(),
                $head = $filter.filter('.head');

            //if anker look for parent group as active
            if ($anker.length && $filter.length && hash !== '') {
                hash = $anker.parent().data('filter');
                $search = $groups.filter('[data-filter="' + hash + '"]');
                $active = $filter.find('a').filter('[href="#' + hash + '"]').parent();
            }

            //filtering content
            if ($search.length && $filter.length && hash !== '') {
                $groups.addClass('is-hidden');
                $search.removeClass('is-hidden');
            }
            else {
                $groups.removeClass('is-hidden');
            }

            //set menufilter active
            if ($search.length && $filter.length && $active.length){
                $filter.blur().removeClass('is-active');
                $active.addClass('is-active');
            }
            else if ($head.length && $filter.length){
                $filter.blur().removeClass('is-active');
                $head.addClass('is-active');
            }

            //if anker scroll to item
            if ($anker.length && hash !== '') {
                $('body').animate({'scrollTop': $anker.offset().top - 40});

                $collapsible = $anker.data('collapsible');
                if($collapsible === true){
                    $anker.addClass('is-active');
                }
            }
        }

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
